var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddBillerActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_4705",
    "data-name": "Group 4705",
    transform: "translate(-272 -172)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_4700",
    "data-name": "Group 4700"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2744",
    "data-name": "Rectangle 2744",
    width: 11,
    height: 14,
    rx: 1,
    transform: "translate(272 173)",
    fill: "#fb7823"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4680",
    "data-name": "Group 4680",
    transform: "translate(-18.926 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2745",
    "data-name": "Rectangle 2745",
    width: 3,
    height: 1,
    transform: "translate(292.926 175)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2746",
    "data-name": "Rectangle 2746",
    width: 7,
    height: 1,
    transform: "translate(292.926 178)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2747",
    "data-name": "Rectangle 2747",
    width: 7,
    height: 1,
    transform: "translate(292.926 180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2748",
    "data-name": "Rectangle 2748",
    width: 7,
    height: 1,
    transform: "translate(292.926 182)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_666",
    "data-name": "Ellipse 666",
    transform: "translate(278 172)",
    fill: "#fff",
    stroke: "#fb7823",
    strokeWidth: 0.5
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 4,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 4,
    r: 3.75,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Icon_feather-check",
    "data-name": "Icon feather-check",
    d: "M10.23,9,7.322,11.908,6,10.586",
    transform: "translate(273.892 165.755)",
    fill: "none",
    stroke: "#fb7823",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.5
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddBillerActive);
export default __webpack_public_path__ + "static/media/add-biller-active.2a2f6792.svg";
export { ForwardRef as ReactComponent };